export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; roles: string[] }
  path?: string
  children?: INavigationRoute[]
  query?: any
}

const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'rides-list',
      displayName: 'menu.rides',
      path: 'admin/rides',
      meta: {
        icon: 'material-icons-route',
        roles: ['supervisor', 'admin', 'ride_support', 'business_partner', 'broker'],
      },
      // children: [
      //   {
      //     name: 'rides-list',
      //     displayName: 'menu.rides-table',
      //     path: '/admin/rides',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-list',
      //     path: '/admin/rides?filter=In+Progress',
      //     query: { filter: 'In Progress' },
      //     displayName: 'menu.rides-in-progress',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-list',
      //     path: '/admin/rides?filter=Upcoming',
      //     query: { filter: 'Upcoming' },
      //     displayName: 'menu.rides-upcoming',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-list',
      //     path: '/admin/rides?filter=Unassigned',
      //     query: { filter: 'Unassigned' },
      //     displayName: 'menu.rides-unassigned',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-list',
      //     path: '/admin/rides?filter=Completed',
      //     query: { filter: 'Completed' },
      //     displayName: 'menu.rides-completed',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-list',
      //     path: '/admin/rides?filter=Recently+added',
      //     query: { filter: 'Recently added' },
      //     displayName: 'menu.rides-recent',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      //   {
      //     name: 'rides-new',
      //     displayName: 'menu.new-ride',
      //     path: '/admin/rides/new',
      //     meta: {
      //       icon: 'material-icons-route',
      //     },
      //   },
      // ],
    },
    {
      name: 'users',
      displayName: 'menu.users',
      path: 'users',
      meta: {
        icon: 'material-icons-telegram',
        roles: ['business_partner', 'admin'],
      },
    },
    // {
    //   name: 'telegram-users',
    //   displayName: 'menu.users',
    //   path: '/admin/telegram-users',
    //   meta: {
    //     icon: 'material-icons-telegram',
    //     roles: ['admin'],
    //   },
    // },
    {
      name: 'drivers',
      displayName: 'menu.drivers',
      path: '/admin/drivers',
      meta: {
        icon: 'material-icons-people',
        roles: ['supervisor', 'admin', 'ride_support', 'business_partner'],
      },
    },
    {
      name: 'fleet',
      displayName: 'menu.fleet',
      path: '/admin/fleet',
      meta: {
        icon: 'material-icons-directions_car',
        roles: ['supervisor', 'admin', 'ride_support', 'business_partner'],
      },
    },
    {
      name: 'companies',
      displayName: 'menu.companies',
      path: '/admin/companies',
      meta: {
        icon: 'material-icons-apartment',
        roles: ['admin'],
      },
    },
    {
      name: 'applications',
      displayName: 'menu.driver_applications',
      path: '/admin/applications',
      meta: {
        icon: 'material-icons-description',
        roles: ['admin'],
      },
    },
    {
      name: 'company-applications',
      displayName: 'menu.company_applications',
      path: '/admin/company-applications',
      meta: {
        icon: 'material-icons-apartment',
        roles: ['admin'],
      },
    },
    {
      name: 'phone-requests',
      displayName: 'menu.phone_requests',
      path: '/admin/phone-requests',
      meta: {
        icon: 'material-icons-phone',
        roles: ['admin'],
      },
    },
    {
      name: 'invoices',
      displayName: 'menu.invoices',
      path: '/admin/invoices',
      meta: {
        icon: 'material-icons-description',
        roles: ['admin'],
      },
    },
    // NOTE: Business partner "My Company" details are now shown on the My Account page.
  ] as unknown as INavigationRoute[],
}

export default navigationRoutes
